import UploadTdgDocumentRequestModelBase from '../_generated/modelBases/upload-tdg-document-request-model-base';

export default class UploadTdgDocumentRequestModel extends UploadTdgDocumentRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
